import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button';
import { Project } from '../hooks/useProjects';
import { formatDate } from '../../../pages/ProjectDetailsPage/utils/formatters';

interface ProjectItemProps {
  project: Project;
  onViewAnalysis: (projectId: string) => void;
  onRunAgain: (projectId: string) => void;
  onDelete: (projectId: string) => void;
}

const ProjectItem: React.FC<ProjectItemProps> = ({
  project,
  onViewAnalysis,
  onRunAgain,
  onDelete
}) => {
  const navigate = useNavigate();

  return (
    <div 
      key={project.id} 
      style={{ 
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        padding: '1rem',
        marginBottom: '1rem',
        border: '1px solid #eee'
      }}
    >
      {/* Project Name - Larger and Bold */}
      <h3 style={{ 
        fontSize: '1.1rem', 
        fontWeight: 600, 
        marginBottom: '0.5rem',
        color: '#1e1e1e'
      }}>
        {project.name}
      </h3>
      
      {/* Location */}
      <div style={{ marginBottom: '0.75rem' }}>
        <p style={{ 
          color: '#666', 
          fontSize: '0.9rem',
          marginBottom: '0.25rem'
        }}>
          <strong>Location:</strong> {project.location}
        </p>
      </div>
      
      {/* Status and Last Updated - Side by Side on Same Row */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem',
        flexWrap: 'wrap',
        gap: '0.5rem'
      }}>
        <span style={{ 
          padding: '0.25rem 0.5rem', 
          borderRadius: '4px',
          fontSize: '0.85rem',
          backgroundColor: 
            project.status === 'New' ? '#e6f7ff' : 
            project.status === 'Analyzed' ? '#f6ffed' : 
            '#fff7e6',
          color: 
            project.status === 'New' ? '#1890ff' : 
            project.status === 'Analyzed' ? '#52c41a' : 
            '#fa8c16'
        }}>
          {project.status}
        </span>
        
        <span style={{ 
          fontSize: '0.85rem',
          color: '#666'
        }}>
          Last updated: {formatDate(project.lastUpdated)}
        </span>
      </div>
      
      {/* Action Buttons - Full Width and Prominent */}
      <div style={{ 
        display: 'flex', 
        gap: '0.75rem',
        marginTop: '0.5rem',
        flexWrap: 'wrap'
      }}>
        <Button 
          onClick={() => navigate(`/dashboard/${project.id}`)}
          style={{ 
            padding: '0.5rem 1rem', 
            fontSize: '0.95rem',
            backgroundColor: '#7FE7D9',
            color: '#1e1e1e',
            flex: '1',
            minWidth: '120px'
          }}
        >
          View
        </Button>
        <Button 
          onClick={() => onDelete(project.id)}
          style={{ 
            padding: '0.5rem 1rem', 
            fontSize: '0.95rem',
            backgroundColor: '#fff',
            color: '#ff4d4f',
            border: '1px solid #ff4d4f',
            flex: '1',
            minWidth: '120px'
          }}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default ProjectItem;
